import React from 'react';
import PropTypes from 'prop-types';
import ContentText from 'Components/ContentText';
import DealerModel from 'Stores/DealerModel';
import { getGivenBackground } from 'Utils/getColor';
import styles from './styles.scss';
import RichText from 'Components/RichText';

const DealerPrivacy = ({ dealer }) => {
  return (
    <ContentText
      headline={{
        value: 'Datenschutzerklärung des Mazda Händlers',
        forceUppercase: true,
        level: 'h2',
        className: 'h4',
      }}
      id="autohaus"
      background={getGivenBackground('light')}
    >
      <RichText
        className={styles.dealerPrivacyText}
        content={dealer.settings.imprint.privacyText}
      />
    </ContentText>
  );
};

DealerPrivacy.propTypes = {
  dealer: PropTypes.instanceOf(DealerModel).isRequired,
};

export default DealerPrivacy;
